var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"vuw-background",class:{'vuw-default-padding': _vm.padding}},[_c('div',{staticClass:"vuw-container",class:_vm.extraClass},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }